import TourPackageHttp from "../../tourPackageHttp";
import Http from "../../http";

class TourPackageServices {

static async createPackages(data){
    return TourPackageHttp.post('/packages/create',data);
}

  static async getPackages() {
    return TourPackageHttp.post("/packages");
  }
  static async getPackageById(id) {
    return TourPackageHttp.get(`/packages/${id}`);
  }
  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updatePackage(id, data) {
    console.log(
      "========================================data in the updatePlace",
      data
    );
    return TourPackageHttp.update(`/packages/${id}`, data);
  }
  static async addPackage(data) {
    return TourPackageHttp.post("/packages/create", data);
  }

  static async deletePackage(id) {
    return TourPackageHttp.delete(`/packages/${id}`);
  }

  static async getPackageDetailsById(id){
    return TourPackageHttp.get(`/packagesDetails/${id}`);
  }

  static async updatePackageDetailsById(id,data){
    console.log("data in the updatePackageDetailsById ",data)
    return TourPackageHttp.update(`/packagesDetails/${id}`,data)
  }

 

  static async cruzeTypes(data) {
    // console.error('on the way to get the cruzes', TourPackageHttp);
    return Http.post('/cruzetype', data);
  }

  //Get cruze list if their drivers are online
  static async OnlineCruzeTypes(data) {
    // console.error('on the way to get the cruzes', TourPackageHttp);
    return Http.post('/cruzetype/onlinePartners', data);
  }

  static async serviceRequests() {
    // console.error('on the way to get the servicerequests', TourPackageHttp);
    return TourPackageHttp.get('/servicerequests');
  }

  static async serviceRequestsCreate(data) {
    // console.error('serviceRequestsCreate called with data:', data);
    return await TourPackageHttp.post('/servicerequest/create', data);
  }

  static async partners() {
    return Http.get('/rider/fetchAllRiders');
  }

  static async PartnersNearby(data) {
    // console.error('PartnersNearby called with data:', data);
    return Http.post('/partner/nearbyPartners', data);
  }
  static async PartnersById(id) {
    return Http.get(`/rider/${id}`);
  }
}
export default TourPackageServices;
